import styled, { css } from 'styled-components';
import { Children, useState } from 'react';

const styles = css`
display: flex;
flex-direction: column;
gap: 20px;
> .tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  border-bottom: 1px solid gray;
  //justify-content: space-around;
  padding-left: 5px;
  //padding-right: 20px;
  > .tab {
    position: relative;
    top: 1px;
    font-weight: bold;
    border: 1px solid #bbbbbb;
    color: #999999;
    border-bottom: none;
    border-top-right-radius: 3px;
    border-top-left-radius: 3px;
    padding: 10px;
    padding-top: 5px;
    padding-bottom: 5px;

    &.active {
      background-color: white;
      color: black;
      border-color: #777777

    }
    > .title {
      text-align:center;
      bottom: -2px;
    }
  }
}

> .panels {
  > .panel {
    display: none;
    &.active {
      display: flex;
    }
  }
}
`;


const Tabs = styled(({ className, children, activeTab: initialTab = 0, onTabChange }) => {
  const [activeTab, setActiveTab] = useState(initialTab);
  const isActive = i => (i === activeTab ? 'active' : '');

  const tabs = Children.toArray((children).map((tab, i) => {
    return (
      <div key={i} className={`tab ${isActive(i)}`} onClick={() => {
        setActiveTab(i);
        onTabChange(i);
      }}>
        <div className='title'>
          {tab.props.title}
        </div>
      </div>
    )
  }));

  const panels = Children.toArray((children).map((tab, i) => {
    return (
      <div key={i} className={`panel ${isActive(i)}`}>
        {tab}
      </div>
    )
  }));
  return (
    <div className={className}>
      <div className='tabs'>
        {tabs}
      </div>
      <div className='panels'>
        {panels}
      </div>
    </div>
  )
})`${styles}`;

// const TabTest = () => {

//   return (
//     <div>
//       <Tabs>
//         <div title='Tab 1'>
//           <div>Hello Tab 1 contents</div>
//         </div>
//         <div title='Tab 2'>
//           <div>Hello Tab 2 contents</div>
//         </div>
//       </Tabs>
//     </div>
//   )
// }

export default Tabs;